import { createPortalApi, type PortalApi } from '@kraaapf/portal-client';

/**
 * Der Zugriff auf den Master — eine Instanz für die ganze Anwendung.
 *
 * ## Warum ein Modul-Singleton und kein Provide/Inject
 *
 * Weil es genau einen Master gibt und die Instanz keinen Zustand hält, den man
 * je Komponente unterschiedlich haben wollte. Ein `provide`/`inject`-Paar
 * brächte eine Zeile Ritual an jeder Aufrufstelle und die Möglichkeit, es zu
 * vergessen — für eine Wahl, die es nicht gibt.
 *
 * Für Tests ist das kein Hindernis: Geprüft wird der Rahmen selbst
 * (`packages/portal-client`) mit einem eingesetzten `fetch`, und Komponenten
 * bekommen ihre Daten als Property.
 *
 * ## Was `onUnauthenticated` tut — und was nicht
 *
 * Es räumt den angemeldeten Benutzer aus dem Store. Es leitet **nicht** um:
 * Der Router hat einen Wächter, der aus „kein Benutzer" die Anmeldung macht,
 * und zwei Stellen, die umleiten, wären zwei Stellen, an denen man in einer
 * Schleife landen kann.
 */
let onUnauthenticatedHook: (() => void) | null = null;

export const api: PortalApi = createPortalApi({
  // In Produktion trennt die Edge diesen Präfix ab, in der Entwicklung der
  // Vite-Proxy. Keine Domain steht im Code.
  baseUrl: '/api',
  onUnauthenticated: () => onUnauthenticatedHook?.(),
});

/**
 * Hinterlegt, was bei einer endgültig abgelaufenen Sitzung passieren soll.
 *
 * Wird beim Start einmal vom Auth-Store gesetzt. Die Umkehrung — der Store
 * kennt den Client — wäre ein Kreis: Der Client braucht den Rückruf, bevor der
 * Store existiert.
 */
export function setUnauthenticatedHandler(handler: () => void): void {
  onUnauthenticatedHook = handler;
}
